import { render, staticRenderFns } from "./SupportButton.vue?vue&type=template&id=4fc91964"
import script from "./SupportButton.vue?vue&type=script&lang=js"
export * from "./SupportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports